<template>
  <v-icon small>mdi-apple</v-icon>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
